<!-- <section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/images/bg_4.jpg');"  *ngIf="showContactInfo"> -->
<section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div class="row no-gutters slider-text align-items-center justify-content-center">
            <div class="col-md-9 pt-5 text-center">
                <p class="breadcrumbs"><span class="mr-2"><a href="">Home <i class="fa fa-chevron-right"></i></a></span>
                    <span>Signup<i class="fa fa-chevron-right"></i></span>
                </p>
                <h1 class="mb-0 bread">
                    Signup
                </h1>
            </div>
        </div>
    </div>
</section>

<section class="ftco-section bg-light">
    <div class="container">
        <div class="row no-gutters justify-content-center">
            <div class="col-md-12">
                <div class="wrapper">
                    <div class="row g-0">
                        <div class="col-lg-6">
                            <div class="contact-wrap w-100 p-md-5 p-4">
                                <h3>
                                    Sign up
                                </h3>
                                <!-- <form id="signupForm" name="signupForm" class="contactForm" method="POST" (ngSubmit)="onSubmit()" > -->
                                <form class="contactForm" id="signupForm" [formGroup]="signupForm" method="POST">

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="emirates">Full Name</label>
                                                <input type="text" class="form-control" name="f_name" id="f_name"
                                                    placeholder="First Name" formControlName="f_name"
                                                    [class.is-invalid]="signupForm.get('f_name')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    First Name is required.
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-12">
                                            <div class="form-group">    
                                                <input type="text" class="form-control" name="l_name" id="l_name"
                                                    placeholder="Last Name" formControlName="l_name"
                                                    [class.is-invalid]="signupForm.get('l_name')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Last Name is required.
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="emirates">Email</label>
                                                <input type="email" class="form-control" name="email" id="email"
                                                    placeholder="Email" formControlName="email"
                                                    [class.is-invalid]="signupForm.get('email')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Email is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="emirates">Phone Number</label>
                                                <input type="text" class="form-control" name="p_num" id="p_num"
                                                    placeholder="Phone Number" formControlName="p_num"
                                                    [class.is-invalid]="signupForm.get('p_num')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    Phone Number is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="emirates">Emirates:</label>
                                                <select class="form-control" formControlName="emirates">
                                                    <option value="">Please select</option>
                                                    <option *ngFor="let e of emirates" [ngValue]="e.id">{{e.city}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="emirates">City</label>
                                                <input type="text" class="form-control" name="city" id="city"
                                                    placeholder="City" formControlName="city"
                                                    [class.is-invalid]="signupForm.get('city')!.invalid && this.submit==true">
                                                <div class="invalid-feedback">
                                                    City is required.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input type="checkbox" id="checkbox1" name="checkbox1" formControlName="check_box"
                                                [class.is-invalid]="signupForm.get('check_box')!.invalid && this.submit==true">
                                                &nbsp;&nbsp;By clicking Sign Up, you agree to our Terms, Privacy Policy and Cookies Policy.
                                                <div class="invalid-feedback">
                                                    Please accept T&C.
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">

                                                <button type="button" (click)="onSubmit()" id="submit"
                                                    class="btn btn-primary">Submit A Property</button>
                                                <!-- <div class="submitting"></div> -->
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <!-- <div class="w-100 social-media mt-5">
                                    <h3>
                                        Follow us here
                                    </h3>
                                    <p>
                                        <a href="#">Facebook</a>
                                        <a href="#">Twitter</a>
                                        <a href="#">Instagram</a>
                                        <a href="#">Dribbble</a>
                                    </p>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-lg-6 d-flex align-items-stretch">
                            <div id="map" class="bg-white"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>